const state = () => {
  return {
    menu: [
      {
        icon: "HomeIcon",
        pageName: "agency-list",
        title: "지점"
      },
      {
        icon: "UsersIcon",
        pageName: "admin-list",
        title: "사용자관리"
      },
      {
        icon: "Corner-Right-DownIcon",
        pageName: "take-in",
        title: "매입"
      },
      {
        icon: "Corner-Right-UpIcon",
        pageName: "take-out",
        title: "매출"
      },
      {
        icon: "Dollar-SignIcon",
        pageName: "hand-amount",
        title: "시재금"
      },
      {
        icon: "ShuffleIcon",
        pageName: "trans-history",
        title: "입출금"
      },
      {
        icon: "Bar-Chart-2Icon",
        pageName: "statistic",
        title: "매출액"
      }
    ]
  };
};

// getters
const getters = {
  menu: state => state.menu
};

// actions
const actions = {};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
